import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@/fontawesome.ts';
import Tooltip from '@/components/ui/Tooltip.tsx';
import { formatDate } from '@/utils/helpers.ts';
import type { RFC3339 } from '@/models/base-types.ts';

interface MigratedTradeIconProps {
  created: RFC3339;
}

// Marker for a trade that was still open when the last session ended and was therefore
// carried over into the current session (see DayTrade.migratedFrom).
export default function MigratedTradeIcon({ created }: MigratedTradeIconProps) {
  return (
    <Tooltip text={`Aus der vorherigen Session übernommen\nDieser Trade war beim Ende der letzten Session noch offen.\nEröffnet am ${formatDate(created)} Uhr.`}>
      <FontAwesomeIcon icon={faCircleInfo} className="w-4 h-4 text-gray-400 dark:text-gray-500 hover:text-blue-500 dark:hover:text-blue-400 transition-colors" />
    </Tooltip>
  );
}
